/**
 * bootprompt.js locale configuration
 * locale : Estonian
 * author : Pavel Krõlov
 */

import { addLocale } from "../bootprompt";

addLocale("et", {
  OK: "OK",
  CANCEL: "Katkesta",
  CONFIRM: "OK",
});
